import axios, { AxiosRequestConfig } from 'axios';
import { MouseEvent } from 'react';

export const handleLinkClick = async (event: MouseEvent<HTMLAnchorElement>, action: string, type: string) => {
    event.preventDefault();
    try {
        let response;
        const config: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/json',
                'Content-Disposition': 'attachment; filename=CorporatePortalTemplate1.0.xlsx'
            },
            withCredentials: true,
            responseType: 'arraybuffer'
        };

        switch (action) {
            case 'template': {
                response = await axios.get(`${process.env.REACT_APP_FILE_SERVICE_API_URL}/fileservice/apifile/v2/download/template/${localStorage.getItem('i18nextLng') ?? 'en'}/${type}`, config);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'CorporatePortalTemplate1.0.xlsx');
                document.body.append(link);
                link.click();
                link.remove();
                break;
            }
            default: {
                break;
            }
        }
    } catch (error) {
        console.log('Error TODO');
    }
};
